<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3><span>新增单位数据表</span></h3>
      </el-col>
    </el-row>
    <div style="max-width: 800px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
        <span style="color:red;margin-left:180px">数据一旦保存将无法修改与删除，请谨慎填写！</span>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="agencyName" label="开票单位名称">
              <el-input ref="agencyName" v-model="form.agencyName" maxlength="120" @focus="() => {
                                            showDiyTree(treeData, form.agencyCode, {title:'开票单位', placeholder: '请输入开票单位名称', treeCallBack: (nodes) => {
                                                let agencyName = ''
                                                if (nodes.length == 0) {
                                                    this.form.agencyCode = ''
                                                } else {
                                                    this.form.agencyCode = nodes[0].id;
                                                    agencyName = nodes[0].label;
                                                    this.form.supProCode = nodes[0].pid;
                                                    this.form.supProName = nodes[0].plabel;
                                                }
                                                this.$set(this.form, 'agencyName', agencyName)
                                                this.$refs.agencyName.blur()
                                            }})
                                          }"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数据源名称" prop="dataSource">
              <el-select v-model="form.dataSource" placeholder="请选择数据源" @change="queryDbNameOption">
                <el-option v-for="item in dataSourceOptions" :key="item.dataSource" :label="item.dataSource" :value="item.dataSource"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据库名称" prop="dbName">
              <el-select v-model="form.dbName" placeholder="请选择数据库">
                <el-option v-for="item in dbNameOptions" :key="item.dbName" :label="item.dbName" :value="item.dbName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="表对照名" prop="tableInfoName">
              <el-input ref="ipt01" v-model="form.tableInfoName" placeholder="请输入表对照名" maxlength="100" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效标志" prop="isValid">
              <el-select v-model="form.isValid">
                <el-option label="有效" value="Y"></el-option>
                <el-option label="无效" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <tree ref="myTree" @treeCallBack="treeCallBack($event)"></tree>
  </div>
</template>

<script>
// import _ from "lodash"
import tree from "./Tree"

let _kits, _form, fn
export default {
  components: {
    tree
  },
  props: ["entity"],
  data() {
    let form = {
      agencyCode: "",
      dataSource: "",
      dbName: "",
      fromName: "",
      tableInfoName: "",
      isValid: "Y"

    };
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      form,
      formRules: {
        agencyName: [{
          required: true,
          message: "请输入开票单位名称",
          trigger: "blur"
        },
        {
          max: 30,
          message: "最多30个字符",
          trigger: "blur"
        }],
        dataSource: [{
          required: true,
          message: "请选择数据源",
          trigger: "blur"
        }],
        dbName: [{
          required: true,
          message: "请选择数据库",
          trigger: "blur"
        }]
      },
      dataSourceOptions: [],
      dbNameOptions: [],
    }
    return data
  },

  created() {
    _kits = this.$kits();
    this.queryDataSourceOption();
    this.initTreeData(data => {
      this.treeData = data
    }, a => {
      //a.disabled =    a.type =='1'     // 添加属性
      //return false
    })
  },

  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: "SAVESYSDB"
    })
    setTimeout(() => {
      this.showLoading = false
      this.showTooltip = true
    }, 300)
  },

  methods: {
    onBack() {
      this.$emit("back")
    },
    onSave() {
      _form.submit()
    },

    //初始化树
    initTreeData(fn_call, fn_filter) {
      _kits.api.call(
        "AGENCYTREE",
        {},
        result => {
          if (result.returnCode == "0000") {
            fn_call(_kits.arr2TreeData(result.data, fn_filter))
          } else {
            this.$message.error(result.returnMsg)
          }
        }
      )
    },
    treeCallBack(nodes) {
      if (fn != undefined) {
        fn(nodes)
      }
    },
    showDiyTree(arr, id, option) {
      fn = option.treeCallBack
      this.$refs.myTree.showTree(arr, id, option)
    },

    //查询数据源下拉信息
    queryDataSourceOption() {
      _kits.api.call(
        "QUERYDATASOURCEOPTION", {
        agencyCode: this.form.agencyCode
      },
        result => {
          if (result.returnCode == "0000") {
            this.dataSourceOptions = result.data;
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    },

    //查询数据库下拉信息
    queryDbNameOption() {
      _kits.api.call(
        "QUERYDBNAMEOPTION", {
        dataSource: this.form.dataSource
      },
        result => {
          if (result.returnCode == "0000") {
            this.dbNameOptions = result.data;
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    },
  },

}
</script>
